/**
 * ViewModeToggle - The Intelligent Standard
 *
 * Button group for toggling between different view modes.
 * Commonly used for grid/json, table/chart, etc.
 */

export interface ViewModeOption {
  label: string;
  value: string;
}

export interface ViewModeToggleProps {
  currentMode: string;
  modes: ViewModeOption[];
  onChange: (mode: string) => void;
}

export function ViewModeToggle({
  currentMode,
  modes,
  onChange,
}: ViewModeToggleProps) {
  return (
    <div
      className="flex rounded-md overflow-hidden"
      style={{ border: '1px solid #E8E0D8' }}
    >
      {modes.map((mode, index) => (
        <button
          key={mode.value}
          onClick={() => onChange(mode.value)}
          className="px-3 py-1.5 text-xs font-medium transition-colors"
          style={{
            background: currentMode === mode.value ? '#8B2332' : '#FFFFFF',
            color: currentMode === mode.value ? '#FFFFFF' : '#6B6B6B',
            borderLeft: index > 0 ? '1px solid #E8E0D8' : 'none',
          }}
        >
          {mode.label}
        </button>
      ))}
    </div>
  );
}
